module.exports = __webpack_public_path__ + "media/images/admin/icons/arrow-up-circle-061f90dce01161d81b25dba56733a64e.svg";